import Statusbar from '../../Statusbar';

const millisecondsInSecond = 1000;

function getVimeoIdFromURL(url) {
	if (!url) return null;

	// If it's already just a numeric ID, return it
	if (/^[0-9]+$/.test(url.trim())) {
		return url.trim();
	}

	// Clean up the URL
	url = url.trim().replace(/\/+$/, '');

	// Extract ID from Vimeo URL patterns
	const patterns = [
		/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)([0-9]+)/,
		/^[0-9]+$/
	];

	for (const pattern of patterns) {
		const match = url.match(pattern);
		if (match && match[1]) {
			return match[1];
		}
	}

	return null;
}

export default function vimeoExecutor({
	videoId, 
	text = '',
	startTime,
	endTime,
	duration = 10,
	muted = false,
}, done, { endEvent }) {
	log(`Notifications.doVimeo "${videoId}" with text "${text}"`);

	Statusbar.addStatus({ title: text });

	if (text || videoId) {
		const vimeoId = getVimeoIdFromURL(videoId);
		
		if (!vimeoId) {
			log('Invalid Vimeo URL or ID provided');
			Screen.logMessageToSentry('Vimeo notification failed - invalid URL/ID');
			done();
			return;
		}

		return playVimeo({
			vimeoId,
			text,
			startTime,
			endTime,
			duration,
			muted
		}, done);
	} else {
		done();
	}
}

function playVimeo({
	vimeoId,
	text,
	startTime,
	endTime,
	duration,
	muted
}, done) {
	// Create the Vimeo embed URL
	let embedUrl = `https://player.vimeo.com/video/${vimeoId}`;
	
	// Add parameters for autoplay and other settings
	const params = new URLSearchParams();
	params.append('autoplay', '1'); // Enable autoplay
	params.append('autopause', '0'); // Don't pause when other videos play
	params.append('loop', '0'); // Don't loop by default
	params.append('title', '0'); // Hide title
	params.append('byline', '0'); // Hide byline
	params.append('portrait', '0'); // Hide portrait
	
	if (startTime) {
		params.append('#t', startTime.toString());
	}
	if (muted) {
		params.append('muted', '1');
		// For better autoplay support on mobile, use background mode when muted
		params.append('background', '1');
	}
	
	embedUrl += `?${params.toString()}`;

	// Create the iframe element
	const iframe = $('<iframe class="notification-vimeo-iframe" />');
	iframe.attr({
		src: embedUrl,
		width: '100%',
		height: '100%',
		frameBorder: '0',
		allow: 'autoplay; fullscreen; picture-in-picture; accelerometer; gyroscope',
		allowFullScreen: true,
		loading: 'eager'
	});

	const notification = createNotificationDOMNode(iframe, text);
	Screen.elements.notifications.append(notification);

	const onEnd = () => {
		log('Vimeo notification closing');
		notification.remove();
		done();
	};

	const onForceEnd = () => {
		log('Vimeo notification closed forcefully');
		onEnd();
	};

	// Show the notification immediately since Vimeo doesn't need complex loading
	notification.removeClass('displaynone');
	log('Vimeo notification playing...');

	// Calculate effective duration
	let effectiveDuration = duration;
	if (startTime && endTime) {
		const segmentDuration = endTime - startTime;
		if (segmentDuration > 0 && segmentDuration < duration) {
			effectiveDuration = segmentDuration;
		}
	}

	// Set up the duration timer
	const durationTimeout = setTimeout(onEnd, effectiveDuration * millisecondsInSecond);

	// Return the force end function so it can be called if needed
	const forceEndFunction = () => {
		clearTimeout(durationTimeout);
		onForceEnd();
	};

	return forceEndFunction;
}

function createNotificationDOMNode(iframe, text) {
	const textDiv = $('<div class="notification-youtube-text"></div>');
	textDiv.text(text);
	
	const el = $('<div class="notification-youtube" />');
	el.append(iframe);
	el.append(textDiv);
	
	const notification = $('<div class="notification" />');
	notification.append($('<div class="overlay"></div>'));
	notification.append(el);
	notification.addClass('displaynone');
	
	return notification;
}
